import { cipo } from 'cipo';

cipo.factory('moduleService', ['$http', '$q', 'URI', 'Model', 'userService', 'Message', function ($http, $q, URI, Model, userService, Message) {

    var moduleService = {};

    moduleService.myDriveName = "";
    moduleService.projectFilesName = "";

    moduleService.getFileModuleNames = function () {

        var p = $q.defer();
        $http[URI.MY_CIPO_DRIVE.FILE_MODULE_NAME.method](URI.MY_CIPO_DRIVE.FILE_MODULE_NAME.toString())
            .then(function (r) {
                if (r && r.data) {
                    moduleService.projectFilesName = r.data.projectFilesName;
                    moduleService.myDriveName = r.data.myDriveName;
                }
                p.resolve(true);
            })
            .catch(function (e) { console.error(e); p.reject(); });

        return p.promise;
    }

    moduleService.getStartScreens = function (moduleId, workflowId, contractId) {

        var p = $q.defer();
        Model[URI.MODULE_GRID.START_SCREENS.method](URI.MODULE_GRID.START_SCREENS, { url: { workflowId: workflowId, contractId: contractId }, urltype: 'obj'}, { headers: { moduleId: moduleId } })
            .then(function (r) {
                p.resolve(r);
            })
            .catch(function (e) { console.error(e); p.reject(); });

        return p.promise;
    }

    moduleService.duplicateDataList = function (type, startScreen, moduleId, relationId, dataListId) {
        var p = $q.defer();

        var module = userService.getModuleObjectById(moduleId);
        var dataURL = type == 'new' ? URI.MODULE_DATA_LIST.CREATE : URI.MODULE_DATA_LIST.DUPLICATE;
        var urlParams =  type == 'duplicate' ? { id: dataListId, screenId: startScreen.key } : {};
        var body = type == 'new' ? { relationId: relationId, screenId: startScreen.key, name: `${module.name} Data List for ${startScreen.value}`, moduleDataListTypeId: 1 } : {};

        Model[dataURL.method](dataURL, { url: urlParams, urltype: 'obj', body: body }, { headers: { moduleId: moduleId } })
            .then(function (r) {
                Message.info(type == 'new' ? "Data List created successfully." : "Data List duplicated successfully.");
                p.resolve(r);
            })
            .catch(function (e) {
                Message.dberror(e);
                console.error(e);
                p.reject(e);
            });
        
        return p.promise;
    }

    moduleService.deleteDataList = function (dataListId, moduleId) {
        var p = $q.defer();

        Model[URI.MODULE_DATA_LIST.DELETE.method](URI.MODULE_DATA_LIST.DELETE, { url: { id: dataListId }, urltype: 'obj' }, { headers: { moduleId: moduleId } })
            .then(function (r) {
                Message.info("Data List deleted successfully.");
                p.resolve(r);
            })
            .catch(function (e) {
                Message.dberror(e);
                console.error(e);
                p.reject(e);
            });
        
        return p.promise;
    }

    return moduleService;
}]);